import styled from "styled-components";
import { Flex } from "antd";
import { featureFlags } from "@settings";

export const StyledContainer = styled.div`
  height: 100%;
`;

export const Mask = styled.div<{ $hideImage?: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;

  &::before,
  &::after {
    content: "";
    background: ${({ theme, $hideImage }) =>
      $hideImage ? `#F5F5F5` : `url('${theme.client.assets.background}')`};
    background-size: cover;
    background-position: ${featureFlags.enableLoginBgAdjustments
      ? "center"
      : "top left"};
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  &::after {
    filter: ${featureFlags.enableLoginBgAdjustments ? "" : "blur(2px)"};
  }
`;

export const ContentWrapper = styled(Flex)`
  height: 100%;
  padding: 20px;
`;
